<template>
	<div v-if="isVisible">
		<!-- <Button
      v-if="!props.icon"
      :severity="props.severity"
      :style="props.customStyle ? props.customStyle : ''"
      :disabled="props.disabled"
      @click="emit('click')"
      :label="props.label"
    >
      <slot />
    </Button>

    <Button
      v-if="props.icon"
      :severity="props.severity"
      :style="props.customStyle ? props.customStyle : ''"
      :disabled="props.disabled"
      @click="emit('click')"
      :label="props.label"
    >
      <slot />
    </Button> -->

		<Button
      :severity="props.severity" :style="props.customStyle ? props.customStyle : ''" :disabled="isDisabled"
			:icon="props.icon" :label="propLabel" @click="emit('click')">
			<slot />
		</Button>
	</div>
</template>

<script lang="ts" setup>
	import type { R3ButtonProps } from "~/types/components/R3/button.types";
	import R3ButtonClass from "./classes/R3Button.classes";

	const props = withDefaults(defineProps<R3ButtonProps>(), {
		severity: null,
		label: "",
		visible: true,
		icon: ""
	});

  const r3Button = new R3ButtonClass(props.label);

  if(props.disabled !== undefined) {
    r3Button.enabled = !props.disabled
  }

  watch(
    () => props.visible,
    (newValue) => {
      r3Button.visible = newValue;
    },
    { immediate: true }
  );

  watch(
      () => props.disabled,
      (isDisabledProp) => {
        if(isDisabledProp !== undefined) {
          r3Button.enabled = !isDisabledProp;
        }
      }
  )

  const isVisible = computed(() => r3Button.visible);

  const isDisabled = computed(() => !r3Button.enabled);

	const emit = defineEmits(["click"]);

  // label
  const labelRef = toRef(props, "label")

  const propLabel = computed({
    get() {
      return labelRef.value !== "" ? labelRef.value : r3Button.text;
    },
    set(value: string) {
      if(value !== undefined && value !== ""){
        r3Button.text = value;
      }
    }
  })




	type ExposeType = {

	} & R3ButtonClass;


	const expose = {

	} as ExposeType


	useExposeProperties(expose, r3Button);
	defineExpose(expose);
</script>

<style lang="scss" scoped></style>
